/**Send a Circular functionality is there in this component */

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateCircularForm.css";
import {
  getbarches,
  getallBanksByRole,
  getThemeURL
} from "../../../../Services/EndPoints";
import { getData, postDataWithBody } from "../../../../Services/Services";

const CreateCircularForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [banksList, setBanksList] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    bank: "",
    branch: "",
    effectiveDate: "",
    priority: "",
    description: "",
  });

  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({
    title: "",
    category: "",
    bank: "",
    branch: "",
    effectiveDate: "",
    priority: "",
  });

  // Map related states
  const [selectedBankId, setSelectedBankId] = useState('');
  const [selectedBank, setSelectedBank] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [filteredBranches, setFilteredBranches] = useState([]);

  useEffect(() => {
    getUserProfile();
  }, []);

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U"; // default value
    if (profile.role_name === "HO") {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null
    };
  };
  // Fetch banks on component mount
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    }
  };

  //Fetch branches based on the bank selection
  const fetchBranches = async (bankId) => {
    try {
      const response = await getData(getbarches.replace("ID", bankId));
      if (response && Array.isArray(response)) {
        setFilteredBranches(response);
      } else {
        console.error(`Invalid branches data format for bank ${bankId}:`, response);
        setFilteredBranches([]);
      }
    } catch (error) {
      console.error(`Error fetching branches for bank ${bankId}:`, error);
      setFilteredBranches([]);
    }
  };

  const handleBankChange = (e) => {
    const bankId = e.target.value;
    setSelectedBankId(bankId);
    setSelectedBank(bankId);
    setSelectedBranch(''); // Reset branch selection when bank changes
    setFormData({ ...formData, bank: bankId });
    setValidationErrors({ ...validationErrors, bank: "" });

    if (bankId) {
      fetchBranches(bankId);
    } else {
      setFilteredBranches([]);
    }
  };

  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    setSelectedBranch(branchId);
    setFormData({ ...formData, branch: branchId });
    setValidationErrors({ ...validationErrors, branch: "" });
  };

  // Input change handler
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    // Clear validation error when user starts typing
    if (validationErrors[id]) {
      setValidationErrors({
        ...validationErrors,
        [id]: ""
      });
    }
  };

  // Handle priority radio button change
  const handlePriorityChange = (e) => {
    setFormData({ ...formData, priority: e.target.value });
    setValidationErrors({ ...validationErrors, priority: "" });
  };

  // Handle image upload
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImages((prevImages) => [
            ...prevImages,
            { file, preview: reader.result },
          ]);
        };
        reader.readAsDataURL(file);
      }
    });
    e.target.value = ""; // Reset input so same files can be selected again
  };

  // Remove selected image
  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  // Form validation
  const validateForm = () => {
    const errors = {
      title: !formData.title ? "Title is required" : "",
      category: !formData.category ? "Circular Category is required" : "",
      bank: !formData.bank ? "Bank is required" : "",
      branch: !formData.branch ? "Branch is required" : "",
      effectiveDate: !formData.effectiveDate ? "Effective Date is required" : "",
      priority: !formData.priority ? "Priority is required" : "",
    };

    setValidationErrors(errors);
    return !Object.values(errors).some(error => error !== "");
  };

  // Form circular creation
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all mandatory fields", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      // Prepare form data for submission
      const submissionData = {
        ...formData,
        images: selectedImages.map(img => img.file.name),
        submittedAt: new Date().toISOString()
      };

      // Log the form data to console
      console.log("Form submitted with data:", submissionData);

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success("Circular created successfully!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });

      // Navigate back after submission
      navigate(-1);

    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Failed to create circular", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>

      {/* fields to create circular */}
      <div className="main-container mt-4">
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="title" className="form-label">
              Title<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control branch-input-form-control ${validationErrors.title ? "is-invalid" : ""}`}
              id="title"
              value={formData.title}
              onChange={handleInputChange}
            />
            {validationErrors.title && (
              <div className="invalid-feedback">
                {validationErrors.title}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="category" className="form-label">
              Circular Category<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.category ? "is-invalid" : ""}`}
              id="category"
              value={formData.category}
              onChange={handleInputChange}
            >
              <option value="" disabled>Select Circular Category</option>
              <option value="HR">HR</option>
              <option value="Compliance">Compliance</option>
              <option value="Finance">Finance</option>
            </select>
            {validationErrors.category && (
              <div className="invalid-feedback">
                {validationErrors.category}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="bank" className="form-label">
              Bank<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.bank ? "is-invalid" : ""}`}
              id="bank"
              value={selectedBank}
              onChange={handleBankChange}
              required
            >
              <option value="">Select Bank</option>
              {banksList.map((bank) => (
                <option key={bank.id} value={bank.id}>
                  {bank.bankName}
                </option>
              ))}
            </select>
            {validationErrors.bank && (
              <div className="invalid-feedback">
                {validationErrors.bank}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="branch" className="form-label">
              Branch Name<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.branch ? "is-invalid" : ""}`}
              id="branch"
              value={selectedBranch}
              onChange={handleBranchChange}
              // disabled={!selectedBank}
              required
            >
              <option value="">Select Branch</option>
              {filteredBranches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.branchName}
                </option>
              ))}
            </select>
            {validationErrors.branch && (
              <div className="invalid-feedback">
                {validationErrors.branch}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="effectiveDate" className="form-label">
              Effective Date<span className="text-danger">*</span>
            </label>
            <input
              type="datetime-local"
              className={`form-control branch-input-form-control ${validationErrors.effectiveDate ? "is-invalid" : ""}`}
              id="effectiveDate"
              value={formData.effectiveDate}
              onChange={handleInputChange}
            />
            {validationErrors.effectiveDate && (
              <div className="invalid-feedback">
                {validationErrors.effectiveDate}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">
              Priority<span className="text-danger">*</span>
            </label>
            <div className="d-flex gap-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="priority"
                  id="priorityHigh"
                  value="High"
                  checked={formData.priority === "High"}
                  onChange={handlePriorityChange}
                />
                <label className="form-check-label" htmlFor="priorityHigh">High</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="priority"
                  id="priorityMedium"
                  value="Medium"
                  checked={formData.priority === "Medium"}
                  onChange={handlePriorityChange}
                />
                <label className="form-check-label" htmlFor="priorityMedium">Medium</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="priority"
                  id="priorityLow"
                  value="Low"
                  checked={formData.priority === "Low"}
                  onChange={handlePriorityChange}
                />
                <label className="form-check-label" htmlFor="priorityLow">Low</label>
              </div>
            </div>
            {validationErrors.priority && (
              <div className="invalid-feedback d-block">
                {validationErrors.priority}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="attachments" className="form-label">
              Upload Images
            </label>
            <input
              type="file"
              className="form-control branch-input-form-control"
              id="attachments"
              accept=".jpg, .jpeg, .png"
              onChange={handleImageChange}
              multiple
            />
            <div className="mt-3 d-flex flex-wrap">
              {selectedImages.map((imgObj, index) => (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    margin: "5px",
                    display: "inline-block",
                  }}
                >
                  <img
                    src={imgObj.preview}
                    alt={`preview-${index}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                  <button
                    onClick={() => removeImage(index)}
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      color: "black",
                      border: "none",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Remove image"
                  >
                    ✖
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              className="form-control branch-input-form-control"
              id="description"
              rows="3"
              maxLength="250"
              value={formData.description}
              onChange={handleInputChange}
            />
            <small className="text-muted">Maximum 250 characters</small>
          </div>
        </div>
      </div>

      {/* submit button */}
      <div className="d-flex justify-content-center">
        <button
          className="branch-save-submit-btn btn btn-success"
          onClick={handleSubmit}
          disabled={isSubmitting || isTextFieldDisable}
        >
          {isSubmitting ? "Submitting..." : "Save & Submit"}
        </button>
      </div>

      <ToastContainer />
    </>
  );
};

export default CreateCircularForm;